import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native";
import SubmitSendOperationScreen from "../SubmitSendOperationScreen";
import {typeExport} from "../../../../../../redux/store/type";
import i18n from "../../../../../../I18n/i18n";
import * as NavigationService from "../../../../../../redux/NavigationService";
import store from "../../../../../../redux/store";
import HMAlert from "../../../../../../customviews/HMAlert";
import {Tools} from "../../../../../../tools/Tools";


const mapStateToProps = (state) => ({
    results: state.reducerSubmitSendOperationScreen.results,
    isLoading: state.reducerSubmitSendOperationScreen.isLoading,
    NoInternetDialog: state.reducerSubmitSendOperationScreen.NoInternetDialog,

    resultsSet: state.reducerSubmitSendOperationScreen.resultsSet,
    isLoadingSet: state.reducerSubmitSendOperationScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerSubmitSendOperationScreen.NoInternetDialogSet,

    position: state.reducerSubmitSendOperationScreen.position,
    id_category: state.reducerSubmitSendOperationScreen.id_category,


    positionPersonnel: state.reducerSubmitSendOperationScreen.positionPersonnel,
    id_Personnel: state.reducerSubmitSendOperationScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    data_splash: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,


});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token, item, index) => dispatch(callWebservice(url, params, type, typeConnection, token, item, index)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token, item, index) => {
    let {ListNotSendRegisterComplaints} = store.getState().reducerSplashGetAllData;
    switch (type) {
        case typeExport.TypeGetSubmitSendOperationScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetSubmitSendOperationScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }


    var date = new Date().getDate(); //Current Date
    var month = new Date().getMonth() + 1; //Current Month
    var year = new Date().getFullYear(); //Current Year
    var hours = new Date().getHours(); //Current Hours
    var min = new Date().getMinutes(); //Current Minutes
    var sec = new Date().getSeconds(); //Current Seconds
    let timeee = date + '_' + month + '_' + year + '_' + hours + '_' + min + '_' + sec;
    let mobile = store.getState().reducerSplashGetAllData.user.mobile;

    let DateTime = new Date().getTime()

    let nameImage = mobile + '_' + DateTime + '.jpg';
    let nameVideo = mobile + '_' + DateTime + '.mp4';

    //  let nameImage = timeee + params.token + ".jpg";
    // let nameVideo = timeee + params.token + ".mp4";
    /// let nameImage = "0123456789012345678901234567890123456789" + ".jpg";
    // let nameVideo = "0123456789012345678901234567890123456789"  + ".mp4";
    const formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('_session', params._session);
    formData.append('type', params.type);

    //"record": itemE
    // "chkChangeIcon"
    // "chkStateNew":
    // "unit": this.st
    // "priority": thi
    formData.append('record', params.record);
    formData.append('chkChangeIcon', params.chkChangeIcon);
    formData.append('comment', params.description);
    formData.append('chkStateNew', params.chkStateNew);
    formData.append('unit', params.unit);
    formData.append('priority', params.priority);
    formData.append('platform', Platform.OS);

    Tools.addAllFormData(formData);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": `Basic ${params.token}`,
            timeout: typeExport._TIMEOUT,
        }
    };
    /*    axios(
            {
                url: baseUrl + url + params,
                method: typeConnection,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
            }
        )*/
    axios.post(url, formData, config)
        .then(async response => {

            let data = response.data;
            switch (type) {
                case typeExport.TypeGetSubmitSendOperationScreen:

                    break;

                case typeExport.TypeSetSubmitSendOperationScreen:
                    if (response.data.success === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));

                        dispatch(serviceActionSuccessSet(data));


                        HMAlert(
                            i18n.t('constant.message'),
                            i18n.t('constant.RequestSuccessfullyRegistered') + (item ? '\n' + i18n.t('constant.updateTheList') : ''),
                            [
                                {
                                    text: item ? i18n.t('constant.ok') : i18n.t('constant.ok'), onPress: () => {
                                        global._refreshListOpertor = true;
                                        NavigationService.BackTo(2)
                                    }


                                },
                                item ? {
                                    text: i18n.t('constant.NowNot'),
                                    onPress: () => {
                                    },
                                    style: 'cancel'
                                } : {},


                            ],
                            {cancelable: true}
                        )


                        //   NavigationService.navigatereset('MainStack');
                    } else {
                        dispatch(serviceActionRefresh());
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.error && response.data.error.message ? response.data.error.message : i18n.t('constant.ServerEncounteredProblemTryingAgain'),
                            [
                                {
                                    text: item ? i18n.t('constant.ok') : i18n.t('constant.ok'), onPress: () => {

                                    }


                                },
                                item ? {
                                    text: i18n.t('constant.NowNot'),
                                    onPress: () => {
                                    },
                                    style: 'cancel'
                                } : {},


                            ],
                            {cancelable: true}
                        )
                    }
                    break;

                default:
            }
        }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetSubmitSendOperationScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetSubmitSendOperationScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token, item, index) => {
    return dispatch => {
        //
        // // if (Platform.OS === 'ios') {
        // //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        // //             if (isConnected) {
        // //                 getDataDisatch(dispatch, url, params, type, typeConnection, token, item,index);
        // //             }
        // //             else {
        // //                 dispatch(serviceActionError("No Internet Connection"));
        // //             }
        // //         }
        // //     );
        // // }
        // // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token, item,index);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case TypegetSubmitSendOperationScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     });
        // //}

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token, item, index);
        //         } else {
        //             switch (type) {
        //
        //                 case typeExport.TypeGetSubmitSendOperationScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token, item, index);
        } else {
            switch (type) {
                case typeExport.TypeGetSubmitSendOperationScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetSubmitSendOperationScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.SubmitSendOperationScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(SubmitSendOperationScreen);
